import { LoadingStates } from '@pb/utils'

export const getAdyen = (state): any => state.adyen
export const getAdyenSDKLoaded = (state): any => getAdyen(state).sdkLoaded
export const getAdyenAction = (state): any => getAdyen(state).actionObject
export const getAdyenConfig = (state): any => getAdyen(state).config

export const getIsAdyenInitStatusSuccess = (state): boolean =>
  getAdyen(state).initStatus === LoadingStates.LoadedSuccess
export const getIsAdyenInitStatusLoading = (state): boolean =>
  getAdyen(state).initStatus === LoadingStates.Loading
export const getIsAdyenInitStatusFail = (state): boolean =>
  getAdyen(state).initStatus === LoadingStates.LoadedFail
